const AUTH_REASON_HEADER = "x-auth-reason";

const readHeaderValue = (headers, headerName) => {
  if (!headers || !headerName) {
    return null;
  }

  const normalizedTarget = String(headerName).toLowerCase();

  if (typeof headers.get === "function") {
    const direct = headers.get(normalizedTarget) || headers.get(headerName);
    return direct ? String(direct) : null;
  }

  const matchedKey = Object.keys(headers).find(
    (key) => key.toLowerCase() === normalizedTarget,
  );

  if (!matchedKey) {
    return null;
  }

  const value = headers[matchedKey];
  return typeof value === "string" && value.trim().length ? value.trim() : null;
};

export const getAuthFailureReason = (error) =>
  readHeaderValue(error?.response?.headers, AUTH_REASON_HEADER);

export const isAccessBlockedResponse = (error) =>
  error?.response?.status === 403 && getAuthFailureReason(error) === "access_blocked";
